<button mat-flat-button color="primary" (click)="addAccessoriesToConstruction()">{{ 'ACCESSORY|Dodaj do całej konstrukcji' | translate }}</button>
@if ((accessories$ | async).length > 0) {
  <div class="icc-list">
    <h4>{{ 'ACCESSORY|Dodatki do całej konstrukcji' | translate }}</h4>
    @for (item of (accessories$ | async); track item) {
      <div class="icc-list-item">
        <ng-container *ngTemplateOutlet="accessoryItem;context:{accessory: item, type: 'accessory'}"></ng-container>
      </div>
    }
  </div>
}

<ng-template #accessoryItem let-item="accessory" let-sash="sash" let-side="side" let-type="type">
  <div class="item-imgTitleDescription">
    <img class="item-imgTitleDescription-img" [src]="getAccessoryImage(item.accessory)" [alt]="item.accessory.name" defaultImg>
    <p class="item-imgTitleDescription-title">@if (windowAccessoriesManufacturerCode) {
      <span>{{item.accessory.manufacturer_code}} </span>
    }{{item.accessory.name}}</p>
    <span class="item-imgTitleDescription-description">
      @if (item.accessory.code) {
        <small>{{item.accessory.code}}</small>
      }
      @if (item.accessory.description) {
        <span [innerHTML]="item.accessory.description" class="item-description"></span>
      }
      <br>

        @if (item.accessory.show_colors && item.accessory.price_source == 'table') {
          <span>{{ 'ACCESSORY|Kolor' | translate }}:
            @if (item.colorOptions == 'white') {
              <b>{{ 'COLOR|Biały' | translate }}</b>
            }
            @if (item.colorOptions == 'color-white') {
              <b>{{ 'COLOR|Kolor' | translate }}/{{ 'COLOR|Biały' | translate }}</b>
            }
            @if (item.colorOptions == 'color-color') {
              <b>{{ 'COLOR|Kolor' | translate }}/{{ 'COLOR|Kolor' | translate }}</b>
            }
            @if (item.colorOptions == 'ral') {
              <b>{{ 'COLOR|RAL' | translate }}</b>
            }
            <br>
            </span>
          }
          @if (item.accessory.price_source == 'confColors') {
            <span>
              @if (item.accessory.selectedWood?.name) {
                <span>{{ 'ACCESSORY|Rodzaj drewna' | translate }}:
                  <b>{{ item.accessory.selectedWood.name }}</b>
                  <br />
                </span>
              }
              @if (item.accessory.selectedColor.outer.name) {
                <span>{{ 'ACCESSORY|Kolor zewn.' | translate }}:
                  <b>{{ item.accessory.selectedColor.outer.name }}</b>
                  <br />
                </span>
              }
              @if (item.accessory.selectedColor.inner.name) {
                <span>{{ 'ACCESSORY|Kolor wewn.' | translate }}:
                  <b>{{ item.accessory.selectedColor.inner.name }}</b>
                  <br />
                </span>
              }
              @if (item.accessory.selectedColor.core.name && showCoreColorInAdditionalProfilesAndAccessories) {
                <span>{{ 'ACCESSORY|Kolor bazy' | translate }}:
                  <b>{{ item.accessory.selectedColor.core.name }}</b>
                  <br />
                </span>
              }
            </span>
          }
          @if (item.accessory.price_source == 'colors' && !item.accessory.fromDependency) {
            <span>
              {{ 'ACCESSORY|Kolor' | translate }}: <b>{{getColor(item.accessory.selectedColor) }}</b><br>
            </span>
          }
          @if (item.accessory.price_source == 'colors' && item.accessory.fromDependency) {
            <span>
              <mat-form-field>
                <mat-label>{{ 'ACCESSORY|Kolor' | translate }}</mat-label>
                <mat-select [(ngModel)]="item.accessory.selectedColor" (ngModelChange)="changeAccessoryColor(item)">
                  @for (color of getAccessoryColors(item); track color) {
                    <mat-option
                      [value]="color.id">
                      {{color.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <br>
              </span>
            }
            @if (commentInAccessory) {
              <span>
                <span >
                  {{ 'INTERFACE|Komentarz' | translate }}: <b>{{item.accessory.comment || item.comment}}@if (!item.editComment) {
                  <mat-icon class='comment__edit' (click)="item.editComment=true">mode_edit</mat-icon>
                }
              </b>
            </span>
            <br>
            </span>
          }
          @if (item.editComment) {
            <textarea [(ngModel)]="item.comment" (focusout)='item.editComment = false' name="" id="" cols="40" rows="5" class='comment__textarea'></textarea>
          }
          @if (item.accessory.type != 'dowel_hole') {
            <span>
              {{ 'ACCESSORY|Ilość' | translate }}: <b>{{item.count}}</b>
            </span>
            }<br />
            @if (item.accessory.price_type == 1 || item.accessory.price_type == 2) {
              <span>
                @if (item.accessory.price_type == 1) {
                  <span >
                    {{ 'ACCESSORY|Powierzchnia' | translate }}:
                  </span>
                }
                @if (item.accessory.price_type == 2) {
                  <span>
                    {{ 'ACCESSORY|Długość' | translate }}:
                  </span>
                }
                <b>
                  @if (item.accessory.price_type == 1) {
                    <span>{{item.amount|unitm2:1}}</span>
                  }
                  @if (item.accessory.price_type == 2) {
                    <span>{{item.amount|unitmm:1}}</span>
                  }
                </b>
              </span>
            }
            @if (item.accessory.currentWidth) {
              <span>
                <span>
                  {{ 'ACCESSORY|Szerokość' | translate }}:
                </span>
                <b>{{item.accessory.currentWidth|unitmm:1:0}}</b>
                <br />
              </span>
            }

            @if (item.accessory.currentHeight) {
              <span>
                <span>
                  {{ 'ACCESSORY|Wysokość' | translate }}:
                </span>
                <b>{{item.accessory.currentHeight|unitmm:1:0}}</b>
                <br />
              </span>
            }

            @if (item.accessory.pricing_data && item.accessory.pricing_data[0]?.colors?.length > 0) {
              <span>
                <span>
                  {{ 'ACCESSORY|Kolor' | translate }}:
                </span>
                <b>{{item.accessory.colors_pricing[item.accessory.selectedColor].name}}</b>
                <br />
              </span>
            }
          </span>
          <span class="item-action">
            @if (!item.accessory.no_price && !hiddenPrice) {
              <h4 class="item-price">
                {{ 'CONFIGURATOR|Cena' | translate }}: @if (getAccessoryPrice(item, true) && getAccessoryPrice(item, true) !== getAccessoryPrice(item)) {
                <s>{{getAccessoryPrice(item, true) | currency:currency}}</s>
                } {{getAccessoryPrice(item) | currency:currency}}
              </h4>
            }
            @if (item.accessory.no_price && !hiddenPrice) {
              <h4 class="item-price item-price_noprice">
                {{ 'CONFIGURATOR|Do wyceny' | translate }}
              </h4>
            }
            <button [disabled]="!item.accessory.addedWithRemovableDependency && item.accessory.fromDependency && item.count == 1"
              mat-raised-button color="primary" (click)="remove(sash || side, item, type)">
              {{ 'INTERFACE|Usuń'| translate}}
            </button>
          </span>
        </div>
      </ng-template>

